import { styled } from "@mui/material";

interface ComponentProps {
    ScoreId: number;
    description: string;
    Score: number;
    ScoreTypeName: string;
}

const ViewRoleContent : React.FC<ComponentProps> = ({ ScoreTypeName, description, Score }) => {
    return (
        <StyledContainer>
            <StyledWrapper>
                <StyledText>Score Type</StyledText>
                <Active>{ScoreTypeName}</Active>
            </StyledWrapper>
            <StyledWrapper>
                <StyledText>Score</StyledText>
                <StyledDate> {Score}</StyledDate>
            </StyledWrapper>
            <StyledWrapper>
                <StyledText2>Description</StyledText2>
            </StyledWrapper>
            <StyledWrapper>
                <StyledText>{description}</StyledText>
            </StyledWrapper>
        </StyledContainer>
    )
}

export default ViewRoleContent;

const StyledContainer = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding-block-start: 3rem;
    padding-block-end: 5rem;
    padding-inline: 2rem;
`

const StyledWrapper = styled('div')`
    display: flex;
    justify-content: space-between;
`

const StyledText = styled('span')`
    font-size: 24px;
    font-weight: 400;
    color: #4E5A62;
`
const StyledText2 = styled('span')`
    font-size: 24px;
    font-weight: 500;
    color: #020D08;
    width:100%
`

const Active = styled('span')`
    font-size: 16px;
    font-weight: 500;
    background-color: #E0FAEE;
    border-radius: 0.4rem;
    padding-inline: 2rem;
    padding-block: 0.5rem;
    color: #11643C;
`

const StyledDate = styled(StyledText)`
    color: #020D08;
    font-weight: 500;
`